<template>
    <div class="border-radius-8 p-4 px-md-2 p-lg-4 dashboard-box dashboard-big-box">
        <img src="/img/employee-dashboard/icon-search-book.svg"
             alt="image-search-and-book"
             class="card-img-top mx-auto d-block mt-5 mb-3">
        <h5 class="font-poppins font-weight-semibold color-blue text-center my-3">
            {{ Lang.get('employeedashboard::pages/dashboard/dashboard.widgets.search_and_book.title') }}
        </h5>

        <ul class="ul-checked-list px-0 px-sm-1 font-weight-light color-dark-blue font-poppins mb-0">
            <li class="ml-md-0 ml-xl-3"
                v-for="listValid in widgets.search_and_book.description_list_valid"
                v-html="listValid"></li>
        </ul>
        <ul v-if="widgets.search_and_book.description_list_invalid"
            class="ul-invalid-list px-0 px-sm-1 font-weight-light color-dark-blue font-poppins">
            <li class="ml-md-0 ml-xl-3"
                v-for="listInValid in widgets.search_and_book.description_list_invalid">
                {{ listInValid }}
            </li>
        </ul>

        <div class="w-100 my-4">
            <a :href="route('nl.employeedashboard.searchAndBook')"
               class="btn bg-fire-orange color-white font-poppins font-weight-bolder radius-19 w-100">
                {{ Lang.get('employeedashboard::pages/dashboard/dashboard.widgets.search_and_book.see_more') }}
            </a>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            widgets: Object,
        }
    }
</script>
